module.exports = __webpack_public_path__ + "media/images/lb/928-7e3dafbacf20494df7fe73aa83b0e5b0.svg";